import moment from "moment";

import { getPolicySupplementDay } from "../../utils";
import { SupplementPerson } from "../../../../../services/SupplementsServices.dto";
import { Column } from "../../../../../components/table-simple/table.types";

export const tableColumns: Column[] = [
  { title: "", key: "order", position: "center" },
  { title: "Nº póliza", key: "polizaId", position: "center" },
  { title: "Roles del cliente", key: "rol", position: "center" },
  { title: "Fecha de última situación", key: "lastDate", position: "center" },
  { title: "Fecha de nueva situación", key: "newDate", position: "center" },
];

export const getTablePersonData = ({
  personData,
  docNumber,
}: {
  personData: SupplementPerson[];
  docNumber: string;
}): { [key: string]: string | number | boolean }[] => {
  const supplementDate = getPolicySupplementDay();
  const policyGroup: { [key: string]: SupplementPerson[] } = {};

  // Agrupamos los intervinientes de cada póliza
  for (let i = 0; i < personData.length; i++) {
    const person = personData[i];
    const policy = person.poliza;
    if (policyGroup[policy]) {
      policyGroup[policy].push(person);
    } else {
      policyGroup[policy] = [person];
    }
  }

  // Seleccionamos de cada grupo el rol del interviniente
  const tableData = Object.values(policyGroup).map((group, index: number) => {
    const policyData = group[0];
    const codRamo = policyData.cod_ramo || "";
    const lastDate = policyData.fec_ult_situa
      ? moment(policyData.fec_ult_situa, "MM/DD/YYYY HH:mm:ss", true).format("DD/MM/YYYY")
      : "";
    const polizaId = codRamo ? `${codRamo} ${policyData.poliza}` : policyData.poliza;
    const newDate = lastDate ? getNewDate({ supplementDate, lastDate }) : supplementDate;

    const row: { [key: string]: string | number | boolean } = {
      order: index + 1,
      polizaId,
      lastDate,
      newDate,
      rol: "",
    };

    const isMascotas = codRamo === "MA01";
    const isTomador = group.some((person) => person.nif_tomador === docNumber);
    const isAsegurado = !isMascotas && group.some((person) => person.nif_asegurado === docNumber);

    if (isTomador && isAsegurado) {
      row.rol = "Tomador, Asegurado";
    } else if (isTomador) {
      row.rol = "Tomador";
    } else {
      row.rol = "Asegurado";
    }

    return row;
  });

  return tableData;
};

/**
 *
 * @param supplementDate DD/MM/YYYY
 * @param lastDate DD/MM/YYYY
 * @returns DD/MM/YYYY || "Fecha inválida" (lastDate >= supplementDate ? lastDate : supplementDate)
 */
const getNewDate = ({
  lastDate,
  supplementDate,
}: {
  lastDate: string;
  supplementDate: string;
}): string => {
  if (!lastDate) {
    return supplementDate;
  }

  const last = moment(lastDate, "DD/MM/YYYY", true);
  const supplement = moment(supplementDate, "DD/MM/YYYY", true);

  if (!last.isValid() || !supplement.isValid()) {
    return "Fecha inválida";
  }

  if (last.isSameOrAfter(supplement, "day")) {
    return last.format("DD/MM/YYYY");
  }

  return supplement.format("DD/MM/YYYY");
};
